import { Factory } from 'fishery';
import { attachmentFactory } from '@trukt/factories/attachmentFactory';
import { AttachmentsSearchResponse } from './AttachmentServices.types';

export const searchAttachmentsResponseFactory = Factory.define<AttachmentsSearchResponse>(() => ({
  page: 1,
  rows: 6,
  total: 250,
  results: [
    attachmentFactory.build({
      usage: 'Detention Unloading',
      acl: 'company',
      name: 'Detention Unloading Fabric',
      totalBytes: 18756,
    }),
    attachmentFactory.build({
      usage: 'Proof Of Delivery',
      acl: 'company',
      name: 'Proof Of Delivery Final',
      totalBytes: 1000,
    }),
    attachmentFactory.build({
      usage: 'Exit Pass',
      acl: 'company',
      name: 'Exit Pass Retention Period',
      totalBytes: 600,
    }),
    attachmentFactory.build({
      usage: 'Invoice',
      acl: 'everyone',
      name: 'Invoice',
      totalBytes: 500,
    }),
    attachmentFactory.build({
      usage: 'Lumper Ticket',
      acl: 'owner',
      name: 'Ticket retained for 30 days',
      totalBytes: 500,
    }),
    attachmentFactory.build({
      usage: 'Scale Ticket',
      acl: 'owner',
      name: 'Scale Ticket',
      totalBytes: 6235,
    }),
    attachmentFactory.build({
      usage: 'inspection - vin',
      acl: 'owner',
      name: 'Inspection Photo Vin',
      totalBytes: 623,
      fileLocation:
        'https://media.licdn.com/dms/image/C560BAQHG_kw_-269yg/company-logo_200_200/0/1675209468531?e=2147483647&v=beta&t=lOdJQNTRwQqiK63fdR1bJzcrn5UBtZw6QiDM-EERDVo',
    }),
  ],
}));
